package er.prateek.crossly.data.model

import kotlinx.serialization.Serializable

@Serializable
data class Puzzle(
    val id: String,
    val packId: String,
    val title: String,
    val language: String = "en",
    val difficulty: DifficultyTier,
    val width: Int,
    val height: Int,
    val grid: List<String>,
    val cluesAcross: List<Clue>,
    val cluesDown: List<Clue>,
)

@Serializable
data class CrosswordPack(
    val schemaVersion: Int,
    val packId: String,
    val packVersion: Int,
    val type: String = "CROSSWORD",
    val difficulty: DifficultyTier,
    val puzzles: List<Puzzle>,
)
